import { Box, Text, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

/* ---------- Colors (Matching Screenshot Palette) ---------- */
const COLORS = ["#ff7a7a", "#6c5ce7", "#ffad33", "#ffeaa7", "#c471ed"];

/* ---------- Data (Original Data as requested) ---------- */
const browserData = [
  { name: "Chrome", value: 38 },
  { name: "Firefox", value: 56 },
  { name: "Safari", value: 2 },
  { name: "Others", value: 4 },
];

const osData = [
  { name: "Windows", value: 30 },
  { name: "Linux", value: 45 },
  { name: "Mac", value: 13 },
  { name: "Others", value: 12 },
];

const countryData = [{ name: "India", value: 100 }];

/* ---------- Donut Card Component ---------- */
const DonutCard = ({ title, data }) => (
  <Box
    bg={useColorModeValue("white", "gray.800")}
    p={6}
    borderRadius="12px"
    boxShadow="0 4px 20px rgba(0,0,0,0.05)"
    display="flex"
    flexDirection="column"
    height="100%"
  >
    <Text
      fontSize="16px"
      fontWeight="600"
      mb={6}
      color={useColorModeValue("#334155", "gray.300")}
      fontFamily="Inter, sans-serif"
    >
      {title}
    </Text>

    <Box width="100%" height="320px">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            innerRadius={85}
            outerRadius={145}
            paddingAngle={0}
            dataKey="value"
            stroke="none"
            startAngle={90}
            endAngle={450}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
                stroke="none"
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </Box>
  </Box>
);

/* ---------- Main Component ---------- */
export default function LoginAnalytics() {
  return (
    <SimpleGrid
      columns={{ base: 1, md: 2, lg: 3 }}
      spacing={6}
      mt={8}
    >
      <DonutCard title="Login By Browser (Last 30 days)" data={browserData} />
      <DonutCard title="Login By OS (Last 30 days)" data={osData} />
      <DonutCard title="Login By Country (Last 30 days)" data={countryData} />
    </SimpleGrid>
  );
}
